<template>
  <v-dialog :value="value"
            :persistent="persistent"
            width="700">
    <h6 :class="$modals.modalTitle">
      <slot />
    </h6>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style src="@/styles/modals.scss" lang="scss" module="$modals"></style>
